import { Controller } from "stimulus"

export default class extends Controller {
  static values = { target: String }

  scrollTo(event) {
    event.preventDefault()

    const targetElement = document.querySelector(this.targetValue)
    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: "smooth",
        block: "start"
      })
    }
  }
}